import { parseJSON } from "date-fns";
import { keepPreviousData } from "@tanstack/react-query";
import { addAreaValues, getInterval } from "@helpers";
import { mergeComparisonQuotesByDate } from "@features/investments/investment/utils/mergeQuotes";
import { useHistoricQuotesByTicker } from "@api/v1/hooks/useHistoricQuotesByTicker";

type Props = {
  tickerSymbol?: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
  comparedTickerSymbol?: string;
};

export const useChartData = ({
  tickerSymbol,
  comparedTickerSymbol,
  startDate,
  endDate,
}: Props) => {
  const { data: chartHistoricQuotesData } = useHistoricQuotesByTicker(
    tickerSymbol,
    {
      // TODO: fix wrong typings on backend
      // @ts-ignore
      interval: getInterval(startDate, endDate),
      from: startDate?.toISOString(),
      to: endDate?.toISOString(),
      includeIndexes: false,
    },
    {
      staleTime: Infinity,
      enabled: Boolean(tickerSymbol),
      placeholderData: keepPreviousData,
    }
  );

  const { data: comparisonHistoricQuotes } = useHistoricQuotesByTicker(
    comparedTickerSymbol,
    {
      // TODO: fix wrong typings on backend
      // @ts-ignore
      interval: getInterval(startDate, endDate),
      from: startDate?.toISOString(),
      to: endDate?.toISOString(),
      includeIndexes: false,
    },
    {
      staleTime: Infinity,
      enabled: Boolean(comparedTickerSymbol && tickerSymbol),
      placeholderData: keepPreviousData,
    }
  );

  if (!tickerSymbol) {
    return [];
  }

  const chartData = comparedTickerSymbol
    ? mergeComparisonQuotesByDate(
        chartHistoricQuotesData?.[tickerSymbol] || [],
        comparisonHistoricQuotes?.[comparedTickerSymbol] || []
      )
    : chartHistoricQuotesData?.[tickerSymbol] || [];

  return addAreaValues(
    chartData.map(({ date, ...rest }) => ({
      ...rest,
      date: parseJSON(date),
    })),
    "value"
  );
};
